import { ClientEnv, ClientEnvKey } from '../types/common';

export const getGlobal = <Key extends ClientEnvKey>(key: Key): ClientEnv[Key] => {
  return window.tartleGlobal?.envConfig?.[key];
};
